'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dCategory$002dSearch from "./mealorama.-Category-Search.js";
var $p;
/** @constructor */
function $c_Lmealorama_CategorySearch$() {
}
export { $c_Lmealorama_CategorySearch$ as $c_Lmealorama_CategorySearch$ };
$p = $c_Lmealorama_CategorySearch$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_CategorySearch$;
/** @constructor */
function $h_Lmealorama_CategorySearch$() {
}
export { $h_Lmealorama_CategorySearch$ as $h_Lmealorama_CategorySearch$ };
$h_Lmealorama_CategorySearch$.prototype = $p;
$p.m = (function() {
  return "CategorySearch";
});
$p.aSa = (function(x$0) {
  return new $j_mealorama$002e$002dCategory$002dSearch.$c_Lmealorama_CategorySearch(x$0.g(0), (!(!x$0.g(1))), (x$0.g(2) | 0), (x$0.g(3) | 0), x$0.g(4));
});
var $d_Lmealorama_CategorySearch$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_CategorySearch$, "mealorama.CategorySearch$", ({
  FE: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_CategorySearch$ as $d_Lmealorama_CategorySearch$ };
var $n_Lmealorama_CategorySearch$;
function $m_Lmealorama_CategorySearch$() {
  if ((!$n_Lmealorama_CategorySearch$)) {
    $n_Lmealorama_CategorySearch$ = new $c_Lmealorama_CategorySearch$();
  }
  return $n_Lmealorama_CategorySearch$;
}
export { $m_Lmealorama_CategorySearch$ as $m_Lmealorama_CategorySearch$ };
//# sourceMappingURL=mealorama.-Category-Search$.js.map
